import { render, staticRenderFns } from "./cModalHistoDeleteCarrito.vue?vue&type=template&id=28f7c4de"
import script from "./cModalHistoDeleteCarrito.vue?vue&type=script&lang=js"
export * from "./cModalHistoDeleteCarrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports